import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFirestore } from '@angular/fire/firestore';

import { ButtonSet } from '../../models';
import { BaseService } from './base-dataservice';
import { map } from 'rxjs/operators';

@Injectable()
export class ButtonService extends BaseService<ButtonSet> {
  constructor(afs: AngularFirestore) {
    super('buttonsets', afs);
  }

  // Custom Methods

  getForUser(userId: string): Observable<ButtonSet[]> {
    const coll = this.afs.collection(this.uri, ref => ref.where('userId', '==', userId));

    return coll.snapshotChanges().pipe(
      map(changes => {
        return changes.map(a => {
          const data = a.payload.doc.data() as ButtonSet;
          data.id = a.payload.doc.id;
          return data;
        });
      })
    )
  }

  public getDefaultColors(): string[] {
    return ['blue', 'yellow', 'red', 'green', 'orange'];
  }

  public getDefaultButtonSet(): ButtonSet {
    return {
      name: 'Default',
      description: '',
      buttons: [
        {
          name: 'Press',
          identifier: '1',
          eventType: 'Press',
          type: 'Event',
          color: 'blue',
          lagSeconds: 5,
          leadSeconds: 5
        },
        {
          name: 'Outlet',
          identifier: '2',
          eventType: 'Outlet',
          type: 'Event',
          color: 'blue',
          lagSeconds: 5,
          leadSeconds: 5
        },
        {
          name: 'Circle Entry For',
          identifier: '3',
          eventType: 'Circle Entry For',
          type: 'Event',
          color: 'blue',
          lagSeconds: 5,
          leadSeconds: 5
        },
        {
          name: 'Circle Entry Ag.',
          identifier: '4',
          eventType: 'Circle Entry Ag.',
          type: 'Event',
          color: 'yellow',
          lagSeconds: 5,
          leadSeconds: 5
        },
        {
          name: 'Goal Shot Ag.',
          identifier: '5',
          eventType: 'Goal Shot Ag.',
          type: 'Event',
          color: 'yellow',
          lagSeconds: 5,
          leadSeconds: 5
        },
        {
          name: 'Goal Shot For.',
          identifier: '6',
          eventType: 'Goal Shot For.',
          type: 'Event',
          color: 'blue',
          lagSeconds: 5,
          leadSeconds: 5
        },
        {
          name: 'Goal For',
          identifier: '7',
          eventType: 'Goal For',
          type: 'Event',
          color: 'blue',
          lagSeconds: 5,
          leadSeconds: 5
        },
        {
          name: 'Goal Ag.',
          identifier: '8',
          eventType: 'Goal Ag.',
          type: 'Event',
          color: 'yellow',
          lagSeconds: 5,
          leadSeconds: 5
        },
        {
          name: 'APC',
          identifier: '9',
          eventType: 'APC',
          type: 'Event',
          color: 'blue',
          lagSeconds: 5,
          leadSeconds: 5
        },
        {
          name: 'DPC',
          identifier: '10',
          eventType: 'DPC',
          type: 'Event',
          color: 'yellow',
          lagSeconds: 5,
          leadSeconds: 5
        },
        {
          name: 'Special',
          identifier: '11',
          eventType: 'Special',
          type: 'Event',
          color: 'red',
          lagSeconds: 5,
          leadSeconds: 5
        }
      ]
    } as ButtonSet;
  }
}
